import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IntegrationHealthSummary } from 'src/app/admin/models/integration-status-health.model';
import { NgChartsModule } from 'ng2-charts';
import { ActiveElement, Chart, ChartEvent, ChartOptions } from 'chart.js';
import { Store } from '@ngrx/store';
import { IntegrationDashboardActions } from '../../state/integration-dashboard.actions';

@Component({
    selector: 'nova-health-glance',
    standalone: true,
    imports: [DatePipe, NgChartsModule],
    templateUrl: './health-glance.component.html',
    styleUrls: ['./health-glance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthGlanceComponent {
    values = input.required<IntegrationHealthSummary>();

    statuses = computed(() => this.values()?.summary ?? []);
    totalIntegrations = computed(() => this.values()?.total ?? 0);

    // This will update whenever values change, giving us the "as of" time
    asOf = computed(() => {
        this.values(); // Access values to make this computed reactive to input changes
        return new Date();
    });

    chartData = computed(() => {
        const summary = this.statuses();
        return {
            labels: [...summary.map((x) => x.status)],
            datasets: [
                {
                    data: [...summary.map((x) => x.count)],
                    backgroundColor: [...summary.map((x) => x.color)]
                }
            ]
        };
    });

    constructor(private readonly store: Store) {}

    pieChartOptions: ChartOptions<'pie'> = {
        responsive: true,
        onClick: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
            if (elements[0]) {
                this.filter(this.chartData().labels[elements[0].index] as string);
            }
        }
    };

    pieChartLegend = false;

    filter(status: string) {
        this.store.dispatch(IntegrationDashboardActions.setStatus({ status }));
    }
}
